// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { getTitleBoxHeight } from '../common';
export function titleBoxHeight(hasTitleBox, breakpoint) {
  // there is no titlebox
  if (!hasTitleBox) {
    return "0px";
  }

  // calculate height of the titlebox
  var marginBottom = getTitleBoxHeight(breakpoint);
  return "".concat(marginBottom, "px");
}
export var iconWrapperStyles = function iconWrapperStyles(_ref) {
  var hasTitleBox = _ref.hasTitleBox,
    breakpoint = _ref.breakpoint;
  return css({
    position: 'absolute',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: "calc(100% - ".concat(titleBoxHeight(hasTitleBox, breakpoint), ")"),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  });
};
iconWrapperStyles.displayName = 'MediaIconWrapper';